import { IMAGES, waLink } from "@/config/site";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function Dermo() {
  return (
    <section className="section-pad" data-testid="dermo-section" aria-label="Dermocosmesi">
      <div className="container-x grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div className="relative order-2 lg:order-1">
          <Reveal>
            <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem]">
              <img src={IMAGES.dermo.src} alt={IMAGES.dermo.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
              <div aria-hidden="true" className="absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-black/10" />
            </div>
          </Reveal>
          <Reveal delay={0.2} className="absolute -right-3 bottom-10 hidden w-40 sm:block lg:-right-8 lg:w-48">
            <div className="overflow-hidden rounded-3xl border-4 border-[#faf8f5] shadow-[0_24px_48px_-20px_rgba(28,29,31,0.35)]">
              <img src={IMAGES.dermoDetail.src} alt={IMAGES.dermoDetail.alt} loading="lazy" className="aspect-square w-full object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="order-1 lg:order-2">
          <Reveal>
            <span className="eyebrow">
              <span className="text-[#0050e0]/60">02</span> Dermocosmesi
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h-display mt-4 text-3xl leading-[1.08] sm:text-4xl lg:text-5xl">
              La pelle non è mai uguale per tutti.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-[#575a61] sm:text-lg">
              Per questo partiamo sempre dall&rsquo;ascolto. Ti aiutiamo a costruire una routine adatta alle esigenze
              della tua pelle, scegliendo tra trattamenti e marchi dermocosmetici selezionati.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <a
              href={waLink("Ciao, vorrei un consiglio dermocosmetico da Farma Store.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="dermo-advice-button"
              className="btn-primary mt-8"
            >
              <WhatsAppIcon className="h-5 w-5" />
              Chiedici un consiglio
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
